/**
 * Room+ search bar.
 * The markup is a real search form. A pointer tap or click opens the theme's predictive
 * search modal (#search-modal) instead of focusing the inline field. Keyboard users keep
 * typing in place and press Enter to reach the full search results page.
 */
class RpSearchBar extends HTMLElement {
  /** @type {AbortController} */
  #controller = new AbortController();

  connectedCallback() {
    const input = this.querySelector('input[type="search"]');
    if (!(input instanceof HTMLInputElement)) return;

    input.addEventListener('pointerdown', (event) => this.#openModal(event), {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = new AbortController();
  }

  /**
   * @param {PointerEvent} event
   */
  #openModal(event) {
    if (event.button !== 0) return;

    const modal = /** @type {(HTMLElement & { showDialog?: () => void }) | null} */ (
      document.getElementById('search-modal')
    );
    if (typeof modal?.showDialog !== 'function') return;

    event.preventDefault();
    modal.showDialog();
  }
}

if (!customElements.get('rp-search-bar')) {
  customElements.define('rp-search-bar', RpSearchBar);
}
